const ENDPOINT = 'GETartistSongClaimers';
function getArtistSongClaimers(gateway, params = {}) {
    return gateway.get(getArtistSongClaimers.endpoint, params);
}
getArtistSongClaimers.endpoint = ENDPOINT;

export { getArtistSongClaimers as default };
//# sourceMappingURL=getArtistSongClaimers.js.map
